import classNames from "classnames";
import demoChart from "./components/demoChart.svg";
import increase from "../../assets/images/highlights/increase.svg";
import decrease from "../../assets/images/highlights/decrease.svg";
import humid from "../../assets/images/highlights/humid.svg";
import sun from "../../assets/images/highlights/sun.svg";
import moon from "../../assets/images/highlights/moon.svg";
import air from "../../assets/images/highlights/air.svg";
import rain from "../../assets/images/highlights/rain.svg";
import wind from "../../assets/images/highlights/wind.svg";
import { Title } from "../index";
import { HighlightCard } from "./components/HighlightCard";
import { AirQuality, RainIndicator, Temperature, Thermal } from "./components/charts";
import { useLanguage } from "../../components/contexts/LanguageContext";
import translations from "../../components/translations";
import { useGetOUWeather } from "../../hooks/getSelectedOuWeather/useGetSelectedOuWeather";
import WindCompass from "./components/charts/WindCompass";
import { Humidity } from "./components/charts/Humidity";
import styles from "./highlights.module.css"
import { Skeleton } from "@mui/material";
import { Weather } from "../../types/variables/Variables";


const Highlights = () => {
  const { selectedLanguage } = useLanguage();
  const { data, loading } = useGetOUWeather()

  const cardsData = [
    {
      title: `${translations[selectedLanguage].temperature}`,
      // status: "A subir...",
      status: "",
      statusIcon: <img src={increase} alt="" />,
      series: [{ name: "Temperatura", data: [23, 26, 29, 31, 30, 27, 25] }],
      value: data?.maxAirTemperature,
      description: "",
      // description: "A subir com um pico de 31° às 12:00. Baixa de 23° à noite em 06:00.",
      graphcomponent: <Temperature weather={data?.weatherIcon as Weather} />,
    },
    // {
    //   title: `${translations[selectedLanguage].thermalSensation}`,
    //   status: "Quente...",
    //   statusIcon: <img src={increase} alt="" />,
    //   series: [{ name: "Sensação", data: [25, 28, 31, 36, 34, 30, 27] }],
    //   value: "36°",
    //   description: "Quente devido à alta umidade.",
    //   graphcomponent: <Thermal />,
    // },
    // {
    //   title: `${translations[selectedLanguage].airQualityIndex}`,
    //   status: "Boa qualidade do ar.",
    //   statusIcon: <img src={air} alt="" />,
    //   series: [{ name: "IQA", data: [35, 38, 41, 40, 39, 37, 35] }],
    //   value: "%",
    //   description: "Qualidade do ar estável com o principal poluente: PM2.5 8.2 μg/m³.",
    //   graphcomponent: <AirQuality value={41} />,
    // },
    {
      title: `${translations[selectedLanguage].precipitation}`,
      status: "",
      // status: "Sem precipitação.",
      statusIcon: <img src={rain} alt="" />,
      series: [{ name: "Precipitação", data: [0, 0, 0, 0, 0, 0, 0] }],
      value: `${data?.precipitation ? data?.precipitation + "mm" : "0mm"}`,
      description: "",
      // description:  "Sem precipitação nas próximas 24horas.",
      graphcomponent: <RainIndicator value={Number.parseInt(data?.precipitation! ?? 0)} />,
    },
    {
      title: `${translations[selectedLanguage].wind}`,
      status: "",
      // status: "Força: 2 (Brisa Ligeira)",
      statusIcon: <img src={air} alt="" />,
      series: [{ name: "Vento", data: [9, 12, 10, 15, 19, 16, 13] }],
      value: `${data?.wind ? data?.wind + "Km/h" : "--"}`,
      description: "",
      // description: "Estável com médias de 10 km/h (rajadas até 23) esperadas do S durante a noite. Vento 16 km/h.",
      graphcomponent: <WindCompass />
    },
    {
      title: `${translations[selectedLanguage].humidity}`,
      status: "",
      // status: "Muito húmido.",
      statusIcon: <img src={humid} alt="" />,
      series: [{ name: "Humidade", data: [77, 75, 74, 72, 70, 68, 65] }],
      value: `${data?.relHumidity ? data?.relHumidity + "%" : "--"}`,
      description: "",
      // description: "A diminuir com um valor mínimo de 70% às 14:00. Estão previstas condições muito húmida.",
      graphcomponent: <Humidity value={Number(data?.relHumidity ?? 0)} />
    },
    // {
    //   title: `${translations[selectedLanguage].sun}`,
    //   status: null,
    //   statusIcon: <img src={sun} alt="" />,
    //   series: [{ name: "Sol", data: [5, 6, 7, 8, 9, 10, 11] }],
    //   value: "13h 30min",
    //   description: "Nascer às 05:15 e pôr às 18:45.",
    //   graphcomponent: <></>
    // },
    // {
    //   title: `${translations[selectedLanguage].moon}`,
    //   status: null,
    //   statusIcon: <img src={moon} alt="" />,
    //   series: [{ name: "Lua", data: [22, 23, 0, 1, 2, 3, 11] }],
    //   value: "13h 4min",
    //   description: "Nascer às 22:41 e pôr às 11:45.",
    //   graphcomponent: <></>
    // },
  ];
  return (
    <section>
      <Title label={`${translations[selectedLanguage].weatherDetails}`} />
      <div className={styles.highlightCardList}>
        {cardsData.map((card, index) => (
          <div key={index}>
            {
              loading ?
                <Skeleton height={350} />
                :
                <HighlightCard
                  title={card.title}
                  status={card.status}
                  statusIcon={card.statusIcon}
                  value={card?.value!}
                  description={card.description}
                  graphComponent={card.graphcomponent}
                />
            }
          </div>
        ))}
      </div>
    </section>
  );
};

export { Highlights };